import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';

import omitProps from '../../../utils/omitProps';
import { querySelector } from '../../../utils';

export const GetAccrualReport = gql`
  query GetAccrualReportQuery($startDate: String!, $showCompletedJobs: Boolean!) {
    accrual_report(start_date: $startDate, show_completed: $showCompletedJobs) {
      edges {
        node {
          stateChangeAt: state_change_at
          jobNumber: job_number
          state
          accountingState: accounting_state
          firstDate: first_date
          latestDateInOrBeforePeriod: latest_date_in_or_before_period
          numberOfTicketsAccumlated: number_of_tickets_accumulated
          accumulatedEstimatedNetRevenue: accumulated_estimated_net_revenue
          districtName: district_name
          departmentName: department_name
        }
      }
    }   
  }
`;

const marshallData = ({ data, ownProps }) => {
  const accrualReportData = querySelector(data, '$.accrual_report.edges[*].node', []);
  const { loading } = data;
  return {
    ...ownProps,
    data,
    loading,
    accrualReportData,
  };
};

const queryData = graphql(GetAccrualReport, {
  props: marshallData,
});

export const queryGetAccrualReportGQL = compose(
  queryData,
  omitProps(['data']),
);
